// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"61fae16f","529":"e50ddc7c","553":"89105d79","644":"91b81ff9","777":"6abc58a6","787":"02f597ea","890":"eaeda84d","948":"4e60050f"}[chunkId] + ".chunk.js";
};